<template>
  <div class="md:mx-4 lg:mx-8 text-dark">
    <div class="text-center ">


        <div class="flex items-center justify-center">
          <img src="@/assets/images/day2.png" alt="Image" class="mx-auto w-full lg:w-2/3">

        </div>
        <h3 class="text-2xl font-black text-black mt-2">achievement</h3>

        <h1 class="text-5xl font-black text-black mb-2">Action Taker</h1>

        <div class="my-6">
            Welcome to your <span class="font-bold">second day</span>. Consistency is key to success, and you've shown that you have the drive to make real progress.
        </div>

        <div class="flex items-center justify-center mt-4">
            <vs-button icon-pack="feather" icon="icon-arrow-right" @click="save">take the next step</vs-button>
        </div>

        <div class="font-italic font-sm mt-2">
          *Don't forget to share your successes with others
        </div>
    </div>
  </div>

</template>

<script>

export default {
  components: {
  },
  data () {
   return {
    }
  },
  computed: {
  },
  methods: {
    save () {
      this.$emit('hidePopup')
    }
  }
}
</script>
